<template>
  <base-table :data="getCPEs">
    <el-table-column prop="cpe" :label="$t('sections.ords.table.cpe')" />
    <el-table-column
      prop="location_id"
      :label="$t('sections.ords.table.location')"
    />
    <el-table-column :label="$t('sections.ords.table.submissionDate')">
      <template slot-scope="props">
        {{
          props.row.requestDate
            ? formatTime(props.row.requestDate)
            : props.row.requestDate
        }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('sections.ords.table.integrationDate')">
      <template slot-scope="props">
        {{
          props.row.integrationDate
            ? formatTime(props.row.integrationDate)
            : props.row.integrationDate
        }}
      </template>
    </el-table-column>
    <el-table-column
      prop="cpeStatus"
      :label="$t('sections.ords.table.status')"
    />
  </base-table>
</template>
<script>
import { formatTime } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'ORDsListTable',
  data() {
    return {
      data: [
        {
          cpe: 'cpe',
          location: 'location_id',
          requestDate: 'requestDate',
          integrationDate: 'integrationDate',
          status: 'status',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['getCPEs']),
  },
  methods: {
    formatTime,
  },
};
</script>
<style lang="scss" scoped></style>
